export const T = {
  en_GB: {
    expectedReturn: "Expected Return",
    expectedVolatility: "Expected Volatility",
    productCosts: "Product Costs",
  },
  nb_NO: {
    expectedReturn: "Forventet avkastning",
    expectedVolatility: "Forventet volatilitet",
    productCosts: "Produktkostnader",
  },
} as const;
